module.exports = __webpack_public_path__ + "static/img/stock-white.b9e7cd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/stock-white.svg
// module id = 623
// module chunks = 2